
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.981","height":"13.183"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.5 .5)","fill":"none","stroke":"#919191"}},[_c('path',{attrs:{"d":"M7.266 8.245A1.235 1.235 0 116.031 7.01a1.235 1.235 0 011.235 1.235z"}}),_c('rect',{attrs:{"width":"11.981","height":"8.052","rx":"2.448","transform":"translate(0 4.131)","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.822 4.129S2.592-.003 5.99-.003s3.252 4.132 3.252 4.132","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    